import styled, { css } from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  position: relative;
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  padding: 0;
  cursor: pointer;
`;

export const Details = styled.span`
  display: block;
  margin-right: 1.6rem;
  text-align: right;

  ${({ theme }) => theme.media.sm`
    display: none;
  `}
`;

export const Name = styled.span`
  display: block;
  font-weight: 700;
  color: ${({ theme }) => theme.styleGuide.colors.gray[900]};

  ${({ isSplash }) =>
    isSplash
      ? css`
          font-size: 1.6rem;
          line-height: 2.2rem;

          ${({ theme }) => theme.media.sm`
            font-size: 1.7rem;
            line-height: 2.4rem;
          `}
        `
      : css`
          font-size: 1.2rem;
          line-height: 1.6rem;

          ${({ theme }) => theme.media.sm`
            font-size: 1.3rem;
            line-height: 1.7rem;
          `}
        `}
`;

export const Company = styled.span`
  display: block;
  color: ${({ theme }) => theme.styleGuide.colors.gray[700]};

  ${({ isSplash }) =>
    isSplash
      ? css`
          font-size: 1.4rem;
          line-height: 2rem;

          ${({ theme }) => theme.media.sm`
            font-size: 1.5rem;
          `}
        `
      : css`
          font-size: 1.2rem;
          line-height: 1.6rem;

          ${({ theme }) => theme.media.sm`
            font-size: 1.3rem;
            line-height: 1.7rem;
          `}
        `}
`;

export const AvatarContainer = styled.span`
  display: block;
  flex-shrink: 0;
  border-radius: 50%;

  ${({ isSplash }) =>
    isSplash
      ? css`
          width: 6.6rem;
          height: 6.6rem;
          border: 0.3rem solid ${({ theme }) => theme.live.colors.primary};

          ${({ theme }) => theme.media.sm`
            width: 3.5rem;
            height: 3.5rem;
            border-width: 0.1rem;
          `}
        `
      : css`
          width: 3.2rem;
          height: 3.2rem;

          ${({ theme }) => theme.media.sm`
            width: 3.4rem;
            height: 3.4rem;
          `}
        `}

  span {
    width: 100%;
    height: 100%;

    ${({ isSplash }) =>
      isSplash
        ? css``
        : css`
            font-size: 1.4rem;
            line-height: 2rem;

            ${({ theme }) => theme.media.sm`
              font-size: 1.5rem;
            `}
          `}
  }
`;

export const Menu = styled.div`
  min-width: 22.8rem;
  background-color: ${({ theme }) => theme.styleGuide.colors.white};
  box-shadow: ${({ theme }) => theme.styleGuide.shadows.overlay};
  border-radius: 0.4rem;
  transform: translateY(100%);
  position: absolute;
  bottom: -1.2rem;
  right: 0;
`;

export const MenuSection = styled.div`
  font-size: 1.4rem;
  line-height: 2rem;
  padding: 1.6rem;
  color: ${({ theme }) => theme.styleGuide.colors.gray[900]};
  border-bottom: 0.1rem solid
    ${({ theme }) => theme.styleGuide.colors.gray[500]};

  &:last-child {
    border-bottom: 0;
  }

  ${({ theme }) => theme.media.sm`
    font-size: 1.5rem;
  `}

  table {
    border-collapse: collapse;

    td {
      padding: 0;
      white-space: nowrap;

      &:first-child {
        padding-right: 2rem;
      }
    }
  }
`;

export const MobileMenuSection = styled(MenuSection)`
  display: none;

  ${({ theme }) => theme.media.sm`
    display: block;
  `}
`;

export const Link = styled.a`
  text-decoration: none;
  white-space: nowrap;
  color: ${({ theme }) => theme.live.colors.primary};
`;

export const Email = styled.button`
  display: inline-block;
  font-size: 1.4rem;
  font-weight: 600;
  line-height: 2rem;
  width: 100%;
  padding: 0.4rem;
  background-color: ${({ theme }) => theme.live.colors.primary};
  box-shadow: ${({ theme }) => theme.styleGuide.shadows.raised};
  border-radius: 0.4rem;
  color: ${({ theme }) => theme.styleGuide.colors.white};
  cursor: pointer;
  text-decoration: none;
  text-align: center;

  svg {
    width: 2rem;
    height: 2rem;
    margin-right: 1rem;
    fill: currentColor;
  }
`;
